import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/customTableStyle';
import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';
import React from 'react';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IConfirmationDialogBodyProps {
	confirmationDialogBody: string | React.ReactElement;
}

const ConfirmationDialogBody = ({
	confirmationDialogBody = translate('table.are.you.sure'),
}: IConfirmationDialogBodyProps) => {
	const classes = useStyles();
	return (
		<div className={classes.confirmationDialogBody}>
			{typeof confirmationDialogBody === 'string' ? (
				<BodyS>{confirmationDialogBody}</BodyS>
			) : (
				confirmationDialogBody
			)}
		</div>
	);
};

export default ConfirmationDialogBody;
